import React from 'react';
import moment from 'moment';

import { TableComponent, connect } from "./tableComponent";

const newDomain = {
  domain: "",
  default_admin_id: 5,
  default_master_wid: 0
}

class Component extends TableComponent {

  state = {
    item: {
      domain: "",
      default_admin_id: 5,
      default_master_wid: 0
    },
    modalOpen: false,
    error: ""
  }

  makeColumns = () => {
    const columns = [
      {
        Header: "Domain",
        accessor: "domain",
        minWidth: 60,
        Cell: props => <input 
          class="form-control form-control-sm"
          type="text" 
          value={props.original.domain}
          onChange={e => {this.handleChangeData(e.target.value,props)}}     
          onBlur={e => {this.handleSubmitData(props)}}                 
          />,        
      }, {
        Header: "Admin",
        accessor: "default_admin_id",
        minWidth: 70,
        Cell: props => <input 
          class="form-control form-control-sm"
          type="number" 
          value={props.original.default_admin_id}
          onChange={e => {this.handleChangeData(e.target.value,props)}}     
          onBlur={e => {this.handleSubmitData(props)}}                 
          />,
      }, {
        Header: "Master",
        accessor: "default_master_wid",
        minWidth: 70,
        Cell: props => <input 
          class="form-control form-control-sm"
          type="number" 
          value={props.original.default_master_wid}
          onChange={e => {this.handleChangeData(e.target.value,props)}}     
          onBlur={e => {this.handleSubmitData(props)}}                 
          />,
      }, {
        Header: "",
        accessor: "id",
        minWidth: 70,
        Cell: props => <button 
          class="btn"
          onClick={e => this.remove(e,props.value)}>X</button>,
      }
    ]   
    return columns; 
  }

  apiPath = "domains/list"
  editApiPath = "domains/edit"

  tableParams = {
    manual: true,
    sorted: [{
      id: "domain",
      desc: true
    }]    
  }

  openModal = (e) => {
    this.setState({modalOpen: true})
  }

  remove = (e,id) => {
    e.preventDefault()
    if (!confirm("Are you sure?")) return;
    this.setState({error: "", loading: true})
    this.props.api("domains/remove",{id}).then(res => {
      this.fetchData({forceReload: true})
    })
  }

  save = (e) => {
    e.preventDefault()    
    let stateItem = this.state.item
    let item = {
      id: stateItem.id,
      domain: stateItem.domain,
      default_admin_id: stateItem.default_admin_id || 5,
      default_master_wid: stateItem.default_master_wid || 0,
    }
    if (!item.domain) return;
    this.setState({error: "", loading: true})
    this.props.api("domains/create",item).then(res => {
      if (res && res.result) {
        this.setState({
          modalOpen: false,
          item: {
            id: "",
            domain: "",
            default_master_wid: 0,
            default_admin_id: 5,
          },
          loading: false
        });  
        this.fetchData({forceReload: true})
      } else {
        this.setState({
          error: res && res.error ? res.error.toString() : "Server error",
          loading: false
        })
      }
    })
  }

  handleModalInputChange = (event) => {
    const target = event.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    value = target.type === "file" ? target.files[0] : value;
    let item = this.state.item
    item[target.name] = value
    this.setState({item});
  }    

  renderModal() {
    // if (!this.state.user) return;
    return (
      <div>
        <form class={"modal fade black-overlay "+(this.state.modalOpen ? "show d-block" : "")} onSubmit={this.save}>                                    
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  {this.state.item.id ? "Edit" : "Add"}
                </h5>
              </div>
              <div class="modal-body">                             
                  <div class="form-group row">
                    <label class="col-sm-2 col-form-label">Domain</label>
                    <div class="col-sm-10">
                      <input 
                        type="text" 
                        class="form-control" 
                        placeholder="domain" 
                        name="domain" 
                        required
                        value={this.state.item.domain}
                        onChange={this.handleModalInputChange}                              
                        />
                    </div>
                  </div>   
                  <div class="form-group row">
                    <label class="col-sm-2 col-form-label">Admin</label>
                    <div class="col-sm-10">
                      <input 
                        type="number" 
                        class="form-control" 
                        placeholder="Admin" 
                        name="default_admin_id" 
                        required
                        value={this.state.item.default_admin_id}
                        onChange={this.handleModalInputChange}
                      />
                    </div>
                  </div>   
                  <div class="form-group row">
                    <label class="col-sm-2 col-form-label">Master</label>
                    <div class="col-sm-10">
                      <input 
                        type="number" 
                        class="form-control" 
                        placeholder="Master" 
                        name="default_master_wid"
                        required
                        value={this.state.item.default_master_wid}
                        onChange={this.handleModalInputChange}                                     
                      />
                    </div>
                  </div>
                  <div>{this.state.error}</div>
              </div>
              <div class="modal-footer">
                <button 
                  type="button" class="btn warning" 
                  onClick={e => this.setState({modalOpen: false})}>
                  Cancel
                </button>
                <button type="submit" class="btn primary">Save</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    )
  }  

  render() {
    return (
      <div class="">
        {this.renderModal()}
        <div class="row">
          <div class="col-sm col-sm-10 text-center">
            <button class="btn btn-sm success pull-left" onClick={this.openModal}>Add domain</button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="box mt-2">{this.reactTable()}</div>
          </div>
        </div>
      </div> 
    );
  }
}

export default connect(Component,"domains_list",function(state){
  return {
    apiChangeState: state.api.domains_edit || state.api.initial
  }
})